import script from "./SwitchInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./SwitchInput.vue?vue&type=script&setup=true&lang=ts"

import "./SwitchInput.vue?vue&type=style&index=0&id=61db0108&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61db0108"]])

export default __exports__